module.exports = __webpack_public_path__ + "static/media/mission-farms.922c11a6.svg";